import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const WORDPRESS_BASE_URL = "cms.monaonline.com";

const baseQuery = fetchBaseQuery({
  baseUrl: `https://${WORDPRESS_BASE_URL}/graphql`,
});


const runWithRetry = async (fn, args, api, extraOptions, maxRetries = 5) => {
  let retries = 0;
  let delay = 500;

  while (true) {
    const result = await fn(args, api, extraOptions);

    if (
      result.error &&
      result.error.status === 403 &&
      retries < maxRetries
    ) {
      await new Promise((res) => setTimeout(res, delay));
      retries++;
      delay *= 2; 
      continue;
    }

    return result;
  }
};
const resolveDomain = (bcStoreCode) => {
	switch (bcStoreCode) {
	//   case "at":
	// 	return "at.cms-pressable.monaonline.com";
	//   case "nl":
	// 	return "nl.cms-pressable.monaonline.com";
	//   case "ba":
	// 	return "ba.cms-pressable.monaonline.com";
	//   case "hr":
	// 	return "hr.cms-pressable.monaonline.com";
	  case "mk":
		return "mk.cms-pressable.monaonline.com";
	  case "me":
		return "me.cms-pressable.monaonline.com";
	//   case "si":
	// 	return "si.cms-pressable.monaonline.com";
	  case "us":
		return "usa.cms-pressable.monaonline.com";
	  case "en":
		return "en.cms-pressable.monaonline.com";
	  default:
		return `${bcStoreCode}.${WORDPRESS_BASE_URL}`;
	}
  };


export const bigCommerceStoreBaseQuery = async (args, api, extraOptions) => {
  if (args.url !== undefined && args.url !== "") {
    return runWithRetry(baseQuery, args, api, extraOptions);
  }

  const bcStore = api.getState().bcStore.store;

  if (!bcStore) {
    return {
      error: {
        status: 400,
        statusText: "Store unknown",
      },
    };
  }
  const bcStoreCode = bcStore.code;
  const domain = resolveDomain(bcStoreCode);


  let endpointUrl = typeof args === "string" ? args : args.url;

  if (args.body?.query) {
    args.body.query = args.body.query.replace(/\s+/g, " ").trim();
  }

  let adjustedArgs;

  if (args.body?.query?.startsWith("query")) {
    const b = {
      query: JSON.stringify(args.body.query),
      variables: args.body.variables && JSON.stringify(args.body.variables),
    };

    let queryParam = b.query.substring(1, b.query.lastIndexOf('"'));

    delete args.body;

	endpointUrl = `https://${domain}/graphql?query=${queryParam.replace(
		/[\\]+/g,
		""
	  )}`;

    endpointUrl = b.variables
      ? `${endpointUrl}&variables=${b.variables}`
      : endpointUrl;

    adjustedArgs =
      typeof args === "string"
        ? endpointUrl
        : { ...args, url: endpointUrl, method: "GET" };
  } else {
    endpointUrl = `https://${domain}/graphql`;

    adjustedArgs =
      typeof args === "string"
        ? endpointUrl
        : {
            ...args,
            url: endpointUrl,
          };
  }

  return runWithRetry(baseQuery, adjustedArgs, api, extraOptions);
};

export const wordPressGQL = createApi({
  reducerPath: "wordPressGQL",
  baseQuery: bigCommerceStoreBaseQuery,
  endpoints: (builder) => ({}),
});